import React from 'react';
import HeroBanner from '../components/HeroBanner';
import Navbar from '../components/Navbar';
import CardsSection from '../components/CardsSection';
import UseCases from '../components/UseCases';
import CarouselSection from '../components/CarouselSection';
import Footer from '../components/Footer';
import { newsItems } from '../data/SiteData';

const cardData = [
  {
    title: 'Research Models',
    description: 'Find the research you want from our curated models and extensive database of external research',
    color: '#489596',
    buttonText: 'View Models',
    link: '/models',
  },
  {
    title: 'Resources',
    description: 'Want to learn more about the Immune System. Check out our resources',
    color: '#E67350',
    buttonText: 'View Resources',
    link: '/resources',
  },
  {
    title: 'News & Events',
    description: 'Keep up to date with all the latest news & events about research into the human immune system',
    color: '#142434',
    buttonText: 'View News & Events',
    link: '/news-events',
  },
];

const Homepage = () => (
  <div>
    <Navbar />

    <HeroBanner
      heroTitle="Building Immune Digital Twins"
      heroDescription="The immune system plays a vital role in such a wide range of diseases and health conditions, from fighting pathogens to autoimmune disorders. The Building Immune Digital Twins Portal is designed to help deploy Digital Twin technology for precision medicine, especially for diseases involving the human immune system."
      imageUrl="/images/digiTwins.png"
      height="280px"
      bgColor="#f5f5f5"
    />

    <CardsSection cardData={cardData} />
    <UseCases />
    <CarouselSection title="Latest News" items={newsItems} backgroundStyle="white"/>
<Footer />
  </div>
);

export default Homepage;
